import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import React from "react";

const DMDeleteDialog = ({
  open,
  onClose,
  title,
  contentText,
  discardText,
  agreeText,
  onProceed,
  onDiscard=null
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDiscard || onClose} color="primary">
          {discardText}
        </Button>
        <Button onClick={onProceed} color="primary" autoFocus>
          {agreeText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DMDeleteDialog;
